import { render, staticRenderFns } from "./BadgeWithdrawalDialog.vue?vue&type=template&id=2de7a4b1"
import script from "./BadgeWithdrawalDialog.vue?vue&type=script&lang=js"
export * from "./BadgeWithdrawalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports